import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/instrument-field/instrument-field.js';
      import {InstrumentFieldSize} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/instrument-field/instrument-field.js';

      export interface Props {
     size?: InstrumentFieldSize;
     setpoint?: number | undefined;
     hasSetpoint?: boolean;
     hasSrc?: boolean;
     value?: number | undefined;
     maxDigits?: number;
     showZeroPadding?: boolean;
     fractionDigits?: number;
     tag?: string;
     unit?: string;
     src?: string;
     neutralColor?: boolean;
     horizontal?: boolean;
     center?: boolean;
     labelOnly?: boolean;
     off?: boolean;
     autoHideSetpoint?: boolean;
     autoHideDeadband?: number
   }

      
  
      export type {InstrumentFieldSize} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/instrument-field/instrument-field.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcInstrumentField',
  props: {
    size: {},
    setpoint: {},
    hasSetpoint: { type: Boolean },
    hasSrc: { type: Boolean },
    value: {},
    maxDigits: {},
    showZeroPadding: { type: Boolean },
    fractionDigits: {},
    tag: {},
    unit: {},
    src: {},
    neutralColor: { type: Boolean },
    horizontal: { type: Boolean },
    center: { type: Boolean },
    labelOnly: { type: Boolean },
    off: { type: Boolean },
    autoHideSetpoint: { type: Boolean },
    autoHideDeadband: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-instrument-field',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})